import LazyProjectPageOverview from "~/features/ProjectPageV2/ProjectPageContent/LazyProjectPageOverview";

export default function ProjectOverviewPage() {
  return <LazyProjectPageOverview />;
}
